/* Claim cleanup on the serum PDP.

   Everything here was found by auditing the rendered page against the store's own data,
   not by taste. luma-fx.js injects this content at runtime, so it has to be removed at
   runtime too — and repeatedly, because fx re-runs.

   1. THE FABRICATED REVIEW BAND (.crblack). Six hardcoded reviews with masked names and
      a "Verified buyer" label, dated 26 Apr / 09 May / 11 May / 06 Jun / 11 Jun / 13 Jun
      2026 — all BEFORE the product's publish date of 4 Aug 2026. One of them praises
      "super fast shipping" against a 10-18 business-day policy. The store has 13 orders
      all-time. Removed.

   2. "Based on 2,537 happy customers". The 2,537 figure is a UNITS SOLD count. Presenting
      it as a customer/review count is a different claim entirely. Removed. The buy-box
      line "4.8, 2,537 sold" is left exactly as it is — Guy has confirmed that figure and
      asked for it to stay.

   3. "Proven Results" heading. It sits directly above the section's own disclaimer
      reading "Illustrative of a typical twice-daily routine... not guaranteed". No study
      exists. Restored to "What to expect", which is what the section originally said.

   4. "/ 2mo" on the sticky price. Selling plan 4910612692 bills MONTHLY. Over a year the
      page implied $300 against a real $601.

   5. "locked in for life" / "founding price is locked in". The plan is a PERCENTAGE
      discount (15% off the current price), so nothing is locked. Softened to what the
      plan actually does.

   6. The "Sample layout - replace with real verified reviews" placeholder, and the
      testimonial attributed to "M***a, Verified buyer" that the placeholder was warning
      about. */
(function(){
function clean(){
  var R=document.querySelector('.lp'); if(!R) return false;

  /* 1 + 2 - fabricated customer-review band */
  var cr=R.querySelector('.band.crblack');
  if(cr && cr.parentNode) cr.parentNode.removeChild(cr);

  /* 3 - heading that claims proof we do not have */
  var dk=R.querySelector('.band.dark .bh');
  if(dk && /proven results/i.test(dk.textContent)) dk.textContent='What to expect';

  /* 6 - placeholder testimonial with an invented attribution */
  var rev2=R.querySelector('.rev2');
  if(rev2){
    var nm=rev2.querySelector('.nm');
    if(nm && /verified buyer/i.test(nm.textContent)){
      var band=rev2.closest('.band')||rev2;
      if(band.parentNode) band.parentNode.removeChild(band);
    }
  }
  R.querySelectorAll('.pdisc').forEach(function(el){
    if(/sample layout|review app before launch/i.test(el.textContent)) el.parentNode.removeChild(el);
  });

  /* 4 + 5 - subscription wording */
  var walker=document.createTreeWalker(R, NodeFilter.SHOW_TEXT);
  var n;
  while(n=walker.nextNode()){
    var t=n.nodeValue, o=t;
    t=t.replace(/\s*\/\s*2mo/gi,' / mo')
       .replace(/Delivered every 2 months/gi,'Delivered monthly')
       .replace(/Lock in this launch price for life/gi,'Save 15% on every delivery')
       .replace(/your founding price is locked in/gi,'15% off every delivery')
       .replace(/founding price is locked in/gi,'15% off every delivery');
    if(t!==o) n.nodeValue=t;
  }
  return true;
}

document.addEventListener('DOMContentLoaded',function(){
  [60,300,800,1600,2600].forEach(function(d){ setTimeout(clean,d); });
});
window.addEventListener('load',function(){ [300,1200,2400].forEach(function(d){ setTimeout(clean,d); }); });
/* fx re-runs on interaction, so keep watching for a while */
var n=0, iv=setInterval(function(){ n++; clean(); if(n>25) clearInterval(iv); },400);
})();